import { TFunction } from 'i18next';

import { attractionsIcon } from '../../../../assets';
import { AttractionType } from '../../../../types';

export const getTitle = (t: TFunction<'translation', undefined>, titleType: AttractionType): string => {
  switch (titleType) {
    case 'TRIP':
      return t('sections.trips');
    case 'FORKIDS':
      return t('sections.for_kids');
    case 'CULTURE':
      return t('sections.culture');
    case 'FOODS':
      return t('sections.food');
    default:
      return 'Polecane miejsca';
  }
};

export const getIcon = (type: string): string => {
  switch (type) {
    case 'TRIP':
      return attractionsIcon.trip;
    case 'FORKIDS':
      return attractionsIcon.kids;
    case 'CULTURE':
      return attractionsIcon.culture;
    default:
      return attractionsIcon.culture;
  }
};
